export function buildAssistantRegenerateHandlers({
  activeThreadId,
  exchangeId,
  activeQueryVersionIndex,
  onRegenerateAssistantVersion,
}) {
  const run = (mode) => {
    if (!activeThreadId) return
    onRegenerateAssistantVersion?.({
      threadId: activeThreadId,
      exchangeId,
      versionIndex: activeQueryVersionIndex,
      mode,
    })
  }

  return {
    tryAgain: () => run('try_again'),
    thinkLonger: () => run('think_longer'),
    searchWeb: () => run('search_web'),
  }
}
